import React, { useEffect } from "react";
import { useGlobalCtx } from "../../../Context/GlobalContext";
import { useThemeKeyValues } from "../../../Hooks/useThemeKeyValues";
import { useLocation } from "react-router-dom";
import { Loader } from "@progress/kendo-react-indicators";

const ARCSTheme = React.lazy(() => import('../../../Themes/arcs'))
const VerizonTheme = React.lazy(() => import('../../../Themes/verizon'))
const MMRCICTheme = React.lazy(() => import('../../../Themes/mmr-cic'))
const MMRMARSTheme = React.lazy(() => import('../../../Themes/mmr-mars'))
const NRGTheme = React.lazy(() => import('../../../Themes/nrg'))
const CRGTheme = React.lazy(() => import('../../../Themes/crg'))
const ActivisionTheme = React.lazy(() => import('../../../Themes/activision'))
const BethesdaTheme = React.lazy(() => import('../../../Themes/bethesda'))
const KingTheme = React.lazy(() => import('../../../Themes/king'))
const KynetecTheme = React.lazy(() => import('../../../Themes/kynetec'))
const BlizzardTheme = React.lazy(() => import('../../../Themes/blizzard'))
const BungieTheme = React.lazy(() => import('../../../Themes/bungie'))
const EATheme = React.lazy(() => import('../../../Themes/ea'))
const OpinlyTheme = React.lazy(() => import('../../../Themes/opinly'))
const SpencerTheme = React.lazy(() => import('../../../Themes/spencer'))
const BurtsBeesTheme = React.lazy(() => import('../../../Themes/burtsbees'))
const GreatLakesTheme = React.lazy(() => import('../../../Themes/greatlakes'))
const BHVRTheme = React.lazy(() => import('../../../Themes/bhvr'))
const BootsTheme = React.lazy(() => import('../../../Themes/boots'))
const No7Theme = React.lazy(() => import('../../../Themes/no7'))
const PinPointTheme = React.lazy(() => import('../../../Themes/pinpoint'))
const InsightsCentersTheme = React.lazy(() => import('../../../Themes/insightscenters'))
const NoTheme = React.lazy(() => import('../../../Themes/notheme'))
const CustomTheme = React.lazy(() => import('../../../Themes/custom'))
const DisneyTheme = React.lazy(() => import('../../../Themes/disney'))
const BlinkTheme = React.lazy(() => import('../../../Themes/insightspace'))
const ParadoxTheme = React.lazy(() => import('../../../Themes/paradox'))
const UofPennTheme = React.lazy(() => import('../../../Themes/penn'))
const BrightsideTheme = React.lazy(() => import('../../../Themes/brightside'))

export const ThemeSelector = ({ children }: any) => {
  const globalCtx = useGlobalCtx();
  const location = useLocation();
  let component = null;
  const { getThemeKeyValueCommand } = useThemeKeyValues();
  useEffect(() => {
    getThemeKeyValueCommand(globalCtx.Theme, globalCtx.Language);
  }, [])

  useEffect(() => {

  }, [globalCtx.isResourcesLoaded])

  function updateFavicon(iconPath: string) {

    const appPath = location.pathname.endsWith('/') ? location.pathname : `${location.pathname}/`
    const existingFavicons = document.querySelectorAll('link[rel="icon"]');
    existingFavicons.forEach(link => link.remove());
    // Create a new favicon link
    const faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/x-icon';
    faviconLink.href = `${appPath}${iconPath}`;

    // Append to document head
    document.head.appendChild(faviconLink);
  }

  switch (globalCtx.Theme.toLocaleLowerCase()) {
    case 'arcs':
      updateFavicon('themes/arcs/favicons/favicon.ico');
      component = <ARCSTheme />;
      break;
    case 'activision':
      updateFavicon('themes/activision/favicons/favicon.ico');
      component = <ActivisionTheme />;
      break;
    case 'mmr-cic':
      updateFavicon('themes/mmr-cic/favicons/favicon.ico');
      component = <MMRCICTheme />;
      break;
    case 'mmr-mars':
      updateFavicon('themes/mmr-mars/favicons/favicon.ico');
      component = <MMRMARSTheme />;
      break;
    case 'bethesda':
      updateFavicon('themes/bethesda/favicons/favicon.ico');
      component = <BethesdaTheme />;
      break;
    case 'paradox':
      updateFavicon('themes/paradox/favicons/favicon.ico');
      component = <ParadoxTheme />;
      break;
    case 'penn':
      updateFavicon('themes/penn/favicons/favicon.ico');
      component = <UofPennTheme />;
      break;
    case 'nrg':
      updateFavicon('themes/nrg/favicons/favicon.ico');
      component = <NRGTheme />;
      break;
    case 'crg':
      updateFavicon('themes/crg/favicons/favicon.ico');
      component = <CRGTheme />;
      break;
    case 'disney':
      updateFavicon('themes/disney/favicons/favicon.ico');
      component = <DisneyTheme />;
      break;
    case 'blink':
    case 'insightspace':
      updateFavicon('themes/insightspace/favicons/favicon.ico');
      component = <BlinkTheme />;
      break;
    case 'king':
      updateFavicon('themes/king/favicons/favicon.ico');
      component = <KingTheme />;
      break;
    case 'kynetec':
      updateFavicon('themes/kynetec/favicons/favicon.ico');
      component = <KynetecTheme />;
      break;
    case 'verizon':
      updateFavicon('themes/verizon/favicons/favicon.ico');
      component = <VerizonTheme />;
      break;
    case 'blizzard':
      updateFavicon('themes/blizzard/favicons/favicon.ico');
      component = <BlizzardTheme />;
      break;
    case 'bungie':
      updateFavicon('themes/bungie/favicons/favicon.ico');
      component = <BungieTheme />;
      break;
    case 'ea':
    case 'ea-cte':
      updateFavicon('themes/ea/favicons/favicon.ico');
      component = <EATheme />;
      break;
    case 'opinly':
      updateFavicon('themes/opinly/favicons/favicon.ico');
      component = <OpinlyTheme />;
      break;
    case 'spencer':
      updateFavicon('themes/spencer/favicons/favicon.ico');
      component = <SpencerTheme />;
      break;
    case 'burtsbees':
      updateFavicon('themes/burtsbees/favicons/favicon.ico');
      component = <BurtsBeesTheme />;
      break;
    case 'greatlakes':
      updateFavicon('themes/greatlakes/favicons/favicon.ico');
      component = <GreatLakesTheme />;
      break;
    case 'behaviourinteractive':
    case 'bhvr':
      updateFavicon('themes/bhvr/favicons/favicon.ico');
      component = <BHVRTheme />;
      break;
    case 'boots':
    case 'boots-uk':
      component = <BootsTheme />;
      updateFavicon('themes/boots/favicons/favicon.ico');
      break;
    case 'no7':
    case 'boots-us':
      updateFavicon('themes/no7/favicons/favicon.ico');
      component = <No7Theme />;
      break;
    case 'pinpoint':
      updateFavicon('themes/pinpoint/favicons/favicon.ico');
      component = <PinPointTheme />;
      break;
    case 'insightscenters':
      updateFavicon('themes/insightscenters/favicons/favicon.ico');
      component = <InsightsCentersTheme />;
      break;
    case 'brightside':
      updateFavicon('themes/brightside/favicons/favicon.ico');
      component = <BrightsideTheme />;
      break;
    case 'notheme':
      updateFavicon('themes/notheme/favicons/favicon.ico');
      component = <NoTheme />;
      break;
    default:
      if (globalCtx.isResourcesLoaded) {
        updateFavicon('themes/custom/favicons/favicon.ico');
        component = <CustomTheme />;
      }
  }

  return (
    <React.Suspense>
      {globalCtx.isResourcesLoaded ?
        <>
          {component}
          {children}
        </>
        :
        <div className="flex justify-center min-h-screen">
          <Loader className="place-content-center"></Loader>
        </div>

      }
    </React.Suspense>
  )
}